import { z } from 'zod';

/**
 * The two guided tutorials a new member walks through (`member_tutorial_enabled`):
 * `kit` runs from first login to paying for an activation kit, `activate` runs
 * from the Code + PIN appearing in the Vault to the slot being created.
 *
 * `users.tutorial_state` holds how each one ended. NULL on the column means the
 * member is NOT in line for them: only `/auth/signup` (with the switch on) and a
 * member choosing a live run from the Tutorial button write a state. So an
 * imported or admin-created member, or anyone who joined before the switch, is
 * never interrupted. A null ENTRY inside a state means that tutorial is still
 * owed to them.
 */
export const MEMBER_TUTORIAL_KEYS = ['kit', 'activate'] as const;
export type MemberTutorialKey = (typeof MEMBER_TUTORIAL_KEYS)[number];

export type MemberTutorialOutcome = 'done' | 'skipped';

export type MemberTutorialState = Record<MemberTutorialKey, MemberTutorialOutcome | null>;

export const MEMBER_TUTORIAL_NEW: MemberTutorialState = { kit: null, activate: null };

/** `started` re-arms a tutorial the member ended earlier and chose to run again. */
export const memberTutorialUpdateSchema = z.object({
  tutorial: z.enum(MEMBER_TUTORIAL_KEYS),
  status: z.enum(['started', 'done', 'skipped']),
});
export type MemberTutorialUpdate = z.infer<typeof memberTutorialUpdateSchema>;
